import { createBrowserRouter, redirect } from "react-router";
import { Layout } from "./layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Keys } from "./pages/Keys";
import { KeyDetails } from "./pages/KeyDetails";
import { RpcList } from "./pages/RpcList";
import { TronEnergyRental } from "./pages/TronEnergyRental";
import { Recharge } from "./pages/Recharge";
import { Announcements } from "./pages/Announcements";
import { AnnouncementDetail } from "./pages/AnnouncementDetail";
import { BillingStatements } from "./pages/BillingStatements";
import { setRedirectToLogin } from "../api/client";

// 中间件：检查是否已登录（用于登录页）
async function requireGuest() {
  const { useAuthStore } = await import('../stores/modules/auth');
  const authState = useAuthStore.getState();
  
  // 如果已经登录，重定向到首页
  if (authState.isAuthenticated) {
    throw redirect("/");
  }
  
  return null;
}

// 中间件：检查登录状态
async function requireAuth() {
  const { useAuthStore } = await import('../stores/modules/auth');
  const authState = useAuthStore.getState();
  
  if (!authState.isAuthenticated) {
    throw redirect("/login");
  }
  
  return null;
}

// 初始化重定向函数（在模块加载时执行）
setRedirectToLogin(() => {
  // 使用 window.location 进行重定向，避免依赖 React Router 上下文
  window.location.href = '/login';
});

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    loader: requireAuth,
    children: [
      { index: true, Component: Dashboard },
      { path: "keys", Component: Keys },
      { path: "keys/:id/rpc", Component: RpcList },
      { path: "keys/:id/tron-energy", Component: TronEnergyRental },
      { path: "keys/:id", Component: KeyDetails },
      { path: "recharge", Component: Recharge },
      { path: "billing", Component: BillingStatements },
      { path: "announcements", Component: Announcements },
      { path: "announcements/:id", Component: AnnouncementDetail },
    ],
  },
  {
    path: "/login",
    Component: Login,
    loader: requireGuest, // 已登录用户访问登录页时重定向到首页
  },
  {
    path: "*", // 通配符路由，处理所有未匹配的路径
    loader: () => redirect("/"),
  },
]);
